import React from 'react';
import "./onboard-card-style.scss";
import {useTranslation} from "react-i18next";
import OnboardHint from "../onboard-hint-component/OnboardHint";

const OnboardCardPackage = (props) => {
    const {t} = useTranslation();
    const {blue, black, title, remainingUsage, showUnlimitedMessage, hideRemainingUsage} = props;

    return (
        <div className={"onboard-card m-b-16 " + (blue ? 'card-blue ' : ' ') + (!blue && black ? 'card-black' : '')}>
            <div className="onboard-card-row">
                <p className="onboard-card-title">{title}</p>
            </div>
            <div className="onboard-card-column">
                {/*{!hideRemainingUsage && (*/}
                <div className="onboard-card-row">
                    <div className="onboard-card-obj">
                        <div className="onboard-card-sub">{t('card_package.internet_right')}</div>
                        <div className="onboard-card-content">{remainingUsage || "0 MB"}</div>
                    </div>
                </div>
                {/*)}*/}

                {showUnlimitedMessage && (
                    <div className="onboard-card-row">
                        <div className="onboard-card-obj">
                            <div className="onboard-card-sub-root">
                                <div className="onboard-card-sub">{t('card_package.unlimited_messaging')}</div>
                                <OnboardHint
                                    // sideLeft={hideRemainingUsage}
                                    title={t('hint.internet_messages_title')}
                                    content={t('hint.internet_messages_content')}
                                />
                            </div>
                            <div className="onboard-card-content">
                                {t('purchase_package.active')}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
};

export default OnboardCardPackage;
